import { theme } from "../../../Theme";

/** Discrete promo discount bands (user picks exactly one). */
export const PROMO_DISCOUNT_BANDS = ["NO_PROMO", "0-15%", "15-30%", "30-40%"];

export const PROMO_DISCOUNT_BAND_LABELS = {
  NO_PROMO: "No promo",
  "0-15%": "0–15%",
  "15-30%": "15–30%",
  "30-40%": "30–40%",
};

export function bandToDiscountPct(band) {
  if (!band || band === "TOTAL" || band === "NO_PROMO") return 0;
  if (band === "0-15%") return 7.5;
  if (band === "15-30%") return 22.5;
  if (band === "30-40%") return 35;
  const match = String(band).match(/^(\d+)/);
  return match ? Number(match[1]) : 0;
}

/**
 * Maps a band to the decimal value sent as `selected_discount` in the cell-update API.
 * Convention matches the API example: lower bound of the band as a fraction.
 *   NO_PROMO  → 0
 *   0-15%     → 0
 *   15-30%    → 0.15
 *   30-40%    → 0.30
 */
export function bandToSelectedDiscount(band) {
  if (!band || band === "NO_PROMO" || band === "TOTAL") return 0;
  if (band === "0-15%") return 0;
  if (band === "15-30%") return 0.15;
  if (band === "30-40%") return 0.30;
  // Fall back: try to parse the leading number
  const match = String(band).match(/^(\d+(?:\.\d+)?)/);
  return match ? Number(match[1]) / 100 : 0;
}

export function discountPctToBand(pct) {
  if (pct == null || !Number.isFinite(Number(pct))) return null;
  const p = Number(pct);
  if (p <= 0) return "NO_PROMO";
  if (p <= 15) return "0-15%";
  if (p <= 30) return "15-30%";
  return "30-40%";
}

export function getCellSelectedBand(cell) {
  const band = cell?.selectedBand ?? cell?.kpis?.selectedBand;
  if (band && band !== "TOTAL") return band;
  return discountPctToBand(cell?.discountPct);
}

export function formatBandDisplay(band) {
  if (!band || band === "TOTAL") return "—";
  return PROMO_DISCOUNT_BAND_LABELS[band] ?? String(band);
}

/** Promo-type codes from optimize/planner calendar APIs — shown as returned (e.g. "R"). */
export function formatPromoTypeDisplay(promoType) {
  if (promoType == null || promoType === "") return "—";
  const key = String(promoType).trim();
  return key || "—";
}

export function bandChipSx(band) {
  const isNo =
    band === "—" ||
    band == null ||
    band === "NO_PROMO" ||
    String(band).toUpperCase().includes("NO");
  return {
    height: 22,
    fontSize: 11,
    fontWeight: 600,
    maxWidth: "100%",
    backgroundColor: isNo ? "#F2F4F7" : "#EEF1F5",
    color: isNo ? "#757575" : theme.palette.text.primary,
  };
}
